import { StyledInputWrapper } from './InputWrapper.styled';
import { cloneElement, useEffect, useState, useRef } from 'react';

export default function InputWrapper({
  children,
  hasError,
  rules = [],
  help,
  label,
  required,
  className,
}) {
  const [failedRule, setFailedRule] = useState();
  const validationEnabled = useRef(false);

  if (children.length > 1) {
    throw new Error('<InputWrapper /> can only contain one input component');
  }

  // Enable validation only if the input has a value. Works with ant conponents that have a 'value' prop and an 'onChange' prop handler
  const WrappedInput = cloneElement(children, {
    onChange: (...args) => {
      validationEnabled.current = true;
      if (children.props.onChange) children.props.onChange(...args);
    },
  });
  if (children.props.hasOwnProperty('value')) {
    validationEnabled.current = true;
  }

  useEffect(() => {
    if (validationEnabled.current) {
      setFailedRule(
        rules.find((rule) => {
          return !rule.requirement;
        })
      );
    }
  }, [rules]);

  return (
    <StyledInputWrapper className={className}>
      <div className={`input-label${required ? ' required' : ''}`}>
        <label>{label}</label>
      </div>
      <div
        className={`wrapped-input${
          hasError || failedRule ? ' has-error ant-form-item-has-error' : ''
        }`}
      >
        {WrappedInput}
      </div>
      <div
        className={`input-explain${hasError || failedRule ? ' has-error' : ''}`}
      >
        {failedRule ? failedRule.errorMessage : help}
      </div>
    </StyledInputWrapper>
  );
}
